import React, { useContext } from 'react';
import { SypacText } from '@sypac/component-library-react';
import { useTranslate } from '@tolgee/react';
import { ClientStepperProps } from './ClientStepper.interface';
import { OrderContext } from '../../context/OrderContext/order.context';
import { OrderCreationFlow } from '../../types/order-flow';

const ClientStepper: React.FC<ClientStepperProps> = ({ currentStep, flow }) => {
	const { t } = useTranslate();
	const { order, additional } = useContext(OrderContext);

	const effectiveFlow: OrderCreationFlow =
		flow ?? additional?.orderFlow ?? 'BASE';

	const STEPS =
		effectiveFlow === 'CONTRACT_LOCATION_FIRST'
			? [
					t('clientSelectLocation.enterDeliveryPlace', 'Enter delivery place'),
					t('clientSelectQuantity.selectQuantity', 'Select quantity'),
					order?.deliveryIncluded !== false
						? t(
								'clientSelectQuantity.scheduleYourDelivery',
								'Schedule your delivery',
						  )
						: t(
								'clientSelectQuantity.scheduleYourPickUp',
								'Schedule your pick up',
						  ),
					t(
						'clientSelectQuantity.selectPaymentMethod',
						'Select payment method',
					),
			  ]
			: [
					t('clientSelectQuantity.selectQuantity', 'Select quantity'),
					order?.deliveryIncluded !== false
						? t(
								'clientSelectQuantity.scheduleYourDelivery',
								'Schedule your delivery',
						  )
						: t(
								'clientSelectQuantity.scheduleYourPickUp',
								'Schedule your pick up',
						  ),
					t(
						'clientSelectQuantity.selectPaymentMethod',
						'Select payment method',
					),
			  ];

	const firstStepIndex = Math.max(0, currentStep - 1);
	const displayedSteps = STEPS.slice(firstStepIndex, firstStepIndex + 3);

	return (
		<div className="flex w-[1133px] sm:w-full gap-6 sm:gap-10 items-center">
			{displayedSteps.map((step, index) => {
				const absIndex = index + firstStepIndex;
				const isActive = absIndex + 1 === currentStep;
				return (
					<React.Fragment key={absIndex}>
						<div
							className={`flex gap-4 sm:gap-6 items-center ${
								isActive ? 'text-gray-80' : 'text-gray-10'
							}`}
						>
							<SypacText variant="overline-regular-large">
								<p className="xl-2xl:text-2xl text-base">0{absIndex + 1}</p>
							</SypacText>
							<SypacText variant="overline-regular-large">
								<p
									className={`whitespace-nowrap ${
										isActive
											? 'xl-2xl:text-2xl text-base'
											: 'xl-2xl:text-xl text-base'
									}`}
								>
									{step}
								</p>
							</SypacText>
						</div>
						{index !== displayedSteps.length - 1 && (
							<div
								className={`w-[84px] h-[3px] rounded-full ${
									isActive
										? 'bg-gradient-to-r from-gray-60 to-white'
										: 'bg-gray-10'
								}`}
							/>
						)}
					</React.Fragment>
				);
			})}
		</div>
	);
};

export default ClientStepper;
